import { Paged } from 'api/common/types/Page';
import { PagedSearchCriteria } from 'api/common/types/PagedSearchCriteria';
import CustomFile from 'common/models/CustomFile';
import Http from 'common/services/Http';
import { POLICIES } from '../../Config';
import { UserDto } from './models/UserDto';
import { UsersSelectItemDto } from './models/UsersSelectItemDto';

class UsersService {
    public getList (criteria: PagedSearchCriteria) {
        return Http.get<Paged<UserDto>>('users', criteria);
    }

    public getById (id: string) {
        return Http.get<UserDto>('users/' + id);
    }

    public getAllForSelectItem () {
        return Http.get<UsersSelectItemDto[]>('users/get-all-for-select-item');
    }

    public create (model: UserDto, mediaFile: CustomFile | null): Promise<string> {
        return Http.postWithFile('users', model, mediaFile ? [mediaFile] : []);
    }

    public update (model: UserDto, mediaFile: CustomFile | null) {
        return Http.putWithFile('users', model, mediaFile ? [mediaFile] : []);
    }

    public remove (model: UserDto) {
        return Http.put('users/deactivate', model);
    }

    public hasPolicies (userPolicies: string[], policies: (keyof typeof POLICIES)[], type: 'OR' | 'AND' = 'AND') {
        return type === 'AND'
            ? (policies || []).map(p => !!(userPolicies).find(up => up === POLICIES[p])).filter(p => !p).length === 0
            : (policies || []).map(p => !!(userPolicies).find(up => up === POLICIES[p])).filter(p => p).length > 0;
    }
}

export default new UsersService();
